require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./hei-lo-mammaen-min-kan-mer-om-it-enn-dere.json") })
        }
      }, "path---hei-lo-mammaen-min-kan-mer-om-it-enn-dere");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---hei-lo-mammaen-min-kan-mer-om-it-enn-dere!./.cache/json/hei-lo-mammaen-min-kan-mer-om-it-enn-dere.json
// module id = 376
// module chunks = 231608221292675